import { GlobalStore } from "../../../store/global/GlobalStore";
import { useEffect, useState } from "react";
import { getWaitlistStatus, WaitlistStatus } from "./allowListUtils";

export const useWaitlistStatus = () => {
  const address = GlobalStore.useState(s => s.address);
  const [status, setStatus] = useState<
    { waitlistStatus: WaitlistStatus; hasEmail: boolean } | undefined
  >(undefined);
  useEffect(() => {
    if (address) {
      getWaitlistStatus(address)
        .then(status => {
          setStatus(status);
        })
        .catch(err => {
          console.error(err);
          setStatus({ waitlistStatus: WaitlistStatus.NOT_IN_WAITLIST, hasEmail: false });
        });
    }
  }, [address]);
  return status;
};
